module.exports = __webpack_public_path__ + "img/amd.b89d6046.jpg";